<script lang="ts">
  import { Router, navigate } from 'sly-svelte-location-router'
  import type { Routes } from 'sly-svelte-location-router'
  import { authState, authInitialized } from '@lib/store/auth'
  import {derived, get} from 'svelte/store'
  import ToastContainer from '@components/ToastContainer.svelte'
  import { modalStore } from '@lib/store/modals'
  import { hotkey } from '@lib/directives/hotkey'

  const isAuthenticated = derived(authState, state => state.isAuthenticated)
  const isLoading = derived(authState, state => state.isLoading)

  const openSearchDialog = () => {
    modalStore.set({
      key: 'search-dialog'
    })
  }

  $effect(() => {
    const state = $authState
    const currentPath = window.location.pathname

    if (!state.isLoading && !state.isAuthenticated) {
      if (currentPath.startsWith('/main')) {
        navigate('/login', {
          state: { message: 'Please login to continue' },
          replace: true
        })
      }
    }
  })

  const routes: Routes = {
    '/': '/main',
    '/main': {
      name: 'app',
      component: () => import('@pages/MainPage.svelte'),
      guard: async () => {
        await authInitialized
        const state = get(authState)
        if (!state.isAuthenticated) {
          return {
            path: '/login',
            state: { message: 'Please login to continue' },
            replace: true
          }
        }
      }
    },
    '/login': {
      name: 'login',
      component: () => import('@pages/LoginPage.svelte')
    },
  }
</script>

<ToastContainer />
<button class="hidden" onclick={openSearchDialog} use:hotkey={['ctrl+k', 'cmd+k']}></button>

<Router {routes} fallback={() => import('@pages/ErrorPage.svelte')}>
  <div class="flex items-center justify-center min-h-screen">
    <span class="loading loading-spinner loading-lg"></span>
  </div>
</Router>